import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getRegion } from '../../../utils/Region';
import { SET_DISPLAY_PROFILE_MODAL } from '../redux/profile.types';
import { clearRegisterUser, isUserRegister } from 'utils/register';

export const useProfiles = () => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.user);
  const metadata = useSelector(state => state.metadata);
  const [profilesEnable, setProfilesEnable] = useState(false);
  const [hasChecked, setHasChecked] = useState(false);
  const { displayModal: isProfileManagerShowing } = useSelector(
    state => state.profilesManager,
  );
  const userRegistered = isUserRegister();

  useEffect(
    () => {
      const profilesConfig = JSON.parse(metadata?.profiles_config || '{}');
      const profilesConfigByRegion =
        profilesConfig[getRegion()] || profilesConfig?.default;
      const isProfilesEnable =
        profilesConfigByRegion?.enable &&
        (user.user_id !== undefined || user.user_id !== null);

      if (isProfilesEnable && user.acceptTerms === 1) {
        setHasChecked(true);
        return setProfilesEnable(true);
      }
      setHasChecked(true);
    },
    [user],
  );

  useEffect(
    () => {
      // verificar si se está mostrando el modal
      if (userRegistered) {
        clearRegisterUser();
        return dispatch({ type: SET_DISPLAY_PROFILE_MODAL, payload: false });
      }
      if (isProfileManagerShowing || !profilesEnable) return;

      if (!localStorage.getItem('selectProfile') && profilesEnable)
        return dispatch({ type: SET_DISPLAY_PROFILE_MODAL, payload: true });

      const shouldShowProfiles = JSON.parse(
        localStorage.getItem('selectProfile'),
      );

      shouldShowProfiles?.enable
        ? dispatch({ type: SET_DISPLAY_PROFILE_MODAL, payload: false })
        : dispatch({ type: SET_DISPLAY_PROFILE_MODAL, payload: true });
    },
    [localStorage.getItem('selectProfile'), profilesEnable],
  );

  return {
    profilesEnable,
    hasChecked,
  };
};
